import { MediaResponse, MediaTypes } from './types';

export const getMediaTypeLabel = (mediaType: MediaTypes, lowercase?: boolean): string => {
  switch (mediaType) {
    case MediaTypes.ATTRACT_IMAGE:
      return lowercase ? 'slide' : 'Slide';
    case MediaTypes.ATTRACT_VIDEO:
      return lowercase ? 'video' : 'Video';
    case MediaTypes.LINKED_CONTENT:
      return lowercase ? 'content URL' : 'Linked Content';
    default:
      return lowercase ? 'image' : 'Image';
  }
};

export const getMediaSource = (mediaType: MediaTypes, mediaRecord: MediaResponse): string | null => {
  const { clientId, s3Name } = mediaRecord;

  const baseUrl = `${process.env.REACT_APP_S3_ASSETS}/${clientId}`;

  switch (mediaType) {
    case MediaTypes.ATTRACT_IMAGE:
    case MediaTypes.ATTRACT_VIDEO:
      return `${baseUrl}/${s3Name}`;
    case MediaTypes.BACKGROUND_IMAGE:
      return `${baseUrl}/background_images/${s3Name}`;
    case MediaTypes.EVENT:
      return `${baseUrl}/event_images/${s3Name}`;
    case MediaTypes.INACTIVE_IMAGE:
      return `${baseUrl}/inactive_images/${s3Name}`;
    case MediaTypes.GENRE:
      return `${baseUrl}/genre_images/${s3Name}`;
    case MediaTypes.LOGO_IMAGE:
    case MediaTypes.LOGO_IMAGE_LARGE:
      return `${baseUrl}/logo_images/${s3Name}`;
    case MediaTypes.PROMO_CODE_IMAGE:
      return `${baseUrl}/promo_code_images/${s3Name}`;
    case MediaTypes.SPLASH_IMAGE:
      return `${baseUrl}/splash_images/${s3Name}`;
    case MediaTypes.VENUE:
      return `${baseUrl}/venue_images/${s3Name}`;
    case MediaTypes.LINKED_CONTENT:
    default:
      return null;
  }
};
